export default __webpack_public_path__ + "static/media/beeLightHoneyMobile.14aa2217.jpg";